import { Plot } from '@/components/charts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { ScoreHistogramBucket } from '@/hooks/api/useAnalytics';

import { baseLayout, SCORE_BUCKET_COLORS } from './chart-config';

interface Props {
  data: ScoreHistogramBucket[];
}

export function ScoreDistributionChart({ data }: Props) {
  const sorted = [...data].sort((a, b) => a.min - b.min);
  const colors = sorted.map((d) => SCORE_BUCKET_COLORS[d.bucket] || '#223f5e');

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Score Distribution</CardTitle>
      </CardHeader>
      <CardContent>
        <Plot
          data={[
            {
              type: 'bar',
              x: sorted.map((d) => d.bucket),
              y: sorted.map((d) => d.count),
              marker: {
                color: colors,
                line: { width: 0 },
              },
              hovertemplate: 'Score %{x}<br>Count: %{y}<extra></extra>',
              width: sorted.map(() => 0.7),
            },
          ]}
          layout={baseLayout({
            margin: { l: 50, r: 20, t: 10, b: 60 },
            xaxis: { title: { text: 'Score Range' }, gridcolor: 'rgba(148,163,184,0.15)' },
            yaxis: { title: { text: 'Count' }, gridcolor: 'rgba(148,163,184,0.15)' },
            bargap: 0.15,
            barcornerradius: 4,
          })}
          config={{ displayModeBar: false, responsive: true }}
          useResizeHandler
          className="h-52 w-full"
        />
      </CardContent>
    </Card>
  );
}
